<template>
  <v-container class="pa-0">
    <v-subheader>Brokerage</v-subheader>
    <ferro-menu-item id="side-menu-broker-admin" :route-name="ROUTES.BROKER_ADMIN" icon="mdi-domain" title="Brokerage" />
    <ferro-menu-item v-if="isBrokerageAdmin" title="Configuration" icon="mdi-cog" :route-name="ROUTES.BROKER_CONFIG" />
    <ferro-menu-item
      v-if="isBrokerageAdmin"
      id="side-menu-broker-billing"
      :route-name="ROUTES.BROKER_BILLING"
      icon="mdi-receipt"
      title="Billing"
    />
    <ferro-menu-item
      v-if="isBrokerageAdmin && showBrokerAppLibLink"
      id="side-menu-broker-app-lib"
      :route-name="ROUTES.BROKER_APP_LIB"
      icon="mdi-library"
      title="App Library"
    />
    <ferro-menu-item
      v-if="isBrokerageAdmin && showGlobalPolicyMgmtLink"
      id="side-menu-global-policy-mgmt"
      :route-name="ROUTES.BROKER_GLOBAL_POLICY_MANAGEMENT"
      icon="mdi-file-document-outline"
      title="Global Policies"
    />
  </v-container>
</template>
<script>
import * as routes from '@/router/route-names'
import FerroMenuItem from '@/components/sidemenu/FerroMenuItem'
import { mapGetters } from 'vuex'

export default {
  components: { FerroMenuItem },
  created() {
    this.ROUTES = routes
  },
  methods: {
    goToPage(route) {
      if (this.accountCode) {
        this.$router
          .push({
            name: route,
            params: { accountId: this.accountCode },
          })
          // eslint-disable-next-line no-unused-vars
          .catch(e => {})
      } else {
        this.$router
          .push({
            name: route,
          })
          // eslint-disable-next-line no-unused-vars
          .catch(e => {})
      }
    },
  },
  computed: {
    ...mapGetters({
      isBrokerageAdmin: 'isBrokerageAdmin',
      showBrokerAppLibLink: 'feature_showBrokerAppLibrary',
      showGlobalPolicyMgmtLink: 'feature_showGlobalPolicyManagement',
    }),
    isInBrokerageAdminContext() {
      return this.currentRoutePath.startsWith('/brokerage-administration')
    },
    currentRoutePath() {
      return this.$route.path
    },
  },
}
</script>
<style scoped lang="scss"></style>
